import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeadingComponent from "../../../../../components/HeadingComponent";
import { secondAxios } from "../../../../../api/axios";
import TaskList from "./TaskList";
import { useParams } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const PlantTaskPage = () => {
  const queryClient = new QueryClient();
  const [plant, setPlant] = useState(null);
  const { plantId } = useParams();

  useEffect(() => {
    const getPlant = async () => {
      try {
        const response = await secondAxios.get(`/plant/${plantId}`);
        console.log("selected plant", response.data);
        setPlant({ ...plant, ...response.data });
      } catch (err) {
        console.error("Error fetching plant:", err);
      }
    };
    getPlant();
  }, [plantId]);

  return (
    <QueryClientProvider client={queryClient}>
      <Box padding={"2rem"} sx={{ width: "100%", maxWidth: "100%" }}>
        <HeadingComponent heading="Action Items" />
        {plant && <TaskList selectedPlant={plant} />}
      </Box>
    </QueryClientProvider>
  );
};

export default PlantTaskPage;
